import {Component, Input, OnInit} from '@angular/core';
import {NgForOf, NgIf} from "@angular/common";
import {AppMenuitemComponent} from "./app.menuitem.component";
import {Router} from "@angular/router";
import {ServiceType} from "../api/models/common/manage-portals-response";

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html',
  styleUrl: './app.menu.scss',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    AppMenuitemComponent
  ]
})
export class AppMenuComponent implements OnInit {
  @Input() menuList: any[] = [];
  model: any[] = [];
  isInternalView: boolean = false;

  constructor(private router: Router) {
  }

  ngOnInit(): void {
    const currentRoute = this.router.url;
    this.isInternalView = currentRoute.includes('documentations-portal/internal/view');
    if (currentRoute.includes('/capps-portal')) {
      this.updateMenu(ServiceType.CAPPSPortal)
    } else if (currentRoute.includes('/county-portal')) {
      this.updateMenu(ServiceType.CountyAdminPortal)
    } else if (currentRoute.includes('/general')) {
      this.updateMenu(ServiceType.General)
    }else if (currentRoute.includes('/documentations')) {
      this.updateMenu(ServiceType.Documentation)
    }
  }

  updateMenu(serviceType: number | null) {
    this.model = [];
    switch (serviceType) {
      case ServiceType.CAPPSPortal :
        this.model = [
          {
            label: 'Users',
            icon: 'pi pi-users',
            routerLink: ['/capps-portal/users'],
            routerLinkActiveOptions: {exact: false}
          },
          {
            label: 'Vehicles',
            icon: 'pi pi-car',
            routerLink: ['/capps-portal/vehicle'],
            routerLinkActiveOptions: {exact: false}
          },
          {
            label: 'Invoices',
            icon: 'pi pi-file',
            routerLink: ['/capps-portal/invoices'],
            routerLinkActiveOptions: {exact: false}
          },
          {
            label: 'Pricing Plans',
            icon: 'pi pi-fw pi-book',
            routerLink: ['/capps-portal/pricing-plans'],
            routerLinkActiveOptions: {exact: false}
          },
          {
            label: 'Vehicle Types',
            icon: 'pi pi-fw pi-truck',
            routerLink: ['/capps-portal/vehicle-types'],
            routerLinkActiveOptions: {exact: false}
          },
          {
            label: 'Settings',
            icon: 'pi pi-cog',
            routerLink: ['/capps-portal/setting'],
            routerLinkActiveOptions: {exact: false}
          },
        ];
        break;
      case ServiceType.CountyAdminPortal :
        this.model = [
          {
            label: 'Users',
            icon: 'pi pi-fw pi-users',
            routerLink: ['/county-portal/users'],
            routerLinkActiveOptions: {exact: false},
          },
          {
            label: 'Entities',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/county-portal/entities'],
            routerLinkActiveOptions: {exact: false},
          },
          {
            label: 'Notification Setup',
            icon: 'pi pi-fw pi-bell',
            routerLink: ['/county-portal/notification-setup'],
            routerLinkActiveOptions: {exact: false},
          },
          {
            label: 'Entity Urls',
            icon: 'pi pi-fw pi-link',
            routerLink: ['/county-portal/entity-urls'],
            routerLinkActiveOptions: {exact: false},
          },
          {
            label: 'Manage Learn More',
            icon: 'pi pi-fw pi-question-circle',
            routerLink: ['/county-portal/manage-learn-more'],
            routerLinkActiveOptions: {exact: false}
          },
          {
            label: 'Valid Parcels',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/county-portal/valid-parcels'],
            routerLinkActiveOptions: {exact: false}
          },
          {
            label: 'Roles & Permission Management',
            icon: 'pi pi-fw pi-lock',
            routerLink: ['/county-portal/roles-permissions-manage'],
            routerLinkActiveOptions: { exact: false }
          }
        ];
        break;
        case ServiceType.General :
        this.model = [
          {
            label: 'Counties',
            icon: 'pi pi-globe',
            routerLink: ['/general/counties'],
            routerLinkActiveOptions: {exact: false}
          },{
            label: 'Release Details',
            icon: 'pi pi-fw pi-users',
            routerLink: ['/general/release-details'],
            routerLinkActiveOptions: {exact: false},
          }
          ,{
            label: 'Logs',
            icon: 'pi pi-fw pi-list',
            routerLink: ['/general/logs'],
            routerLinkActiveOptions: {exact: false},
          }
        ];
        break;
      case ServiceType.Documentation :
        this.model = [
          {
            label: 'Internal Products Documentation',
            icon: 'pi pi-fw pi-user',
            routerLink: ['/documentations/internal-products-documentations']
          },
          {
            label: 'Public Products Documentation',
            icon: 'pi pi-fw pi-users',
            routerLink: ['/documentations/public-products-documentations']
          },
        ];
        break;
    }
  }
}
